export default __webpack_public_path__ + "static/newsDetailsSpotlightBanner-dbf6c4fa6822946858d964849aaec663.png";